import AishaCard from '@growdash/growintel/components/atoms/aisha-card';
import { Typography } from '@growdash/design-system/atoms';
import { Loader2 } from 'lucide-react';
import ReactMarkDown from 'react-markdown';

type Props = {
  className?: string;
  isLoading?: boolean;
  result?: string;
};

export default function AishaInsightsView({
  className = '',
  isLoading,
  result,
}: Props) {
  return (
    <AishaCard className={className}>
      {isLoading ? (
        <div className="flex justify-center py-4 animate-pulse">
          <Loader2 className="animate-spin" />
        </div>
      ) : (
        <>
          <div className="my-4">
            <Typography className="text-gradient font-medium animate-slide-in-right">
              Trends
            </Typography>
          </div>
          <Typography className="animate-fade-in text-tertiary font-medium text-sm !leading-[1.25rem]">
            <ReactMarkDown>{result}</ReactMarkDown>
          </Typography>
        </>
      )}
    </AishaCard>
  );
}
